import { MY_COMMUNITY_KEYS } from '../constants'
import { SUBJECTS } from './Abilities'

export const BREADCRUMBS = (title: string) => [
  {
    children: 'My Community',
    href: '/my-community',
    state: { redirectTab: MY_COMMUNITY_KEYS.vendors }
  },
  {
    children: 'Vendors',
    href: '/my-community/vendors',
    state: { redirectTab: MY_COMMUNITY_KEYS.vendors }
  },
  {
    children: title
  }
]

export const VENDORS_TABS_OPTIONS = [
  { label: 'My vendors', value: 'my_vendors' },
  {
    label: 'Vendors repository',
    value: 'vendors_repository'
  }
]

export const VENDORS_TABS_OPTIONS_KEYS = {
  my_vendors: 'my_vendors',
  vendors_repository: 'vendors_repository'
}

export const TAB_SUBJECT_MAP: Record<string, string> = {
  [VENDORS_TABS_OPTIONS[0].value]: SUBJECTS.MY_VENDORS,
  [VENDORS_TABS_OPTIONS[1].value]: SUBJECTS.VENDORS_REPOSITORY
}
